import { useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import Landing from "@/pages/Landing";
import Inbox from "@/pages/Inbox";

function App() {
  // Lock scroll during the cinematic intro, then release.
  const skipIntro =
    typeof window !== "undefined" && new URLSearchParams(window.location.search).has("skipIntro");
  const [introDone, setIntroDone] = useState(skipIntro);
  const handleIntroDone = useCallback(() => setIntroDone(true), []);
  useLenis(introDone);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Landing introDone={introDone} onIntroDone={handleIntroDone} />}
          />
          <Route path="/inbox" element={<Inbox />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
